<template>
  <div class="competition-col-pd">
    <b-row v-for="(error, index) in errors" :key="`${error}-${index}`">
      <p class="mb-1">{{ error }}</p>
    </b-row>
  </div>
</template>
<script>
export default {
  name: 'InputError',
  props: ['errors']
}
</script>
<style scoped>
p {
  color: red;
}
</style>
